/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Walk_InInputs */

const cs_enum_walk_in = /** @type {(inputs: Enum_Walk_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osobně v kanceláři`)
};

const en_enum_walk_in = /** @type {(inputs: Enum_Walk_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walk-in`)
};

/**
* | output |
* | --- |
* | "Walk-in" |
*
* @param {Enum_Walk_InInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_walk_in = /** @type {((inputs?: Enum_Walk_InInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Walk_InInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_walk_in(inputs)
	return cs_enum_walk_in(inputs)
});